function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccount1(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3432_648)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3432_648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.776 462.488L465.833 462.487L462.055 432.099H473.777L473.776 462.488Z",
    fill: "#9E616A",
    style: (_ref2 = {
      fill: "#9E616A"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.6196 0.3804 0.4157)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.802 470.125L450.191 470.124V469.803C450.192 467.18 451.242 464.665 453.111 462.811C454.981 460.957 457.516 459.915 460.16 459.915L475.802 459.916L475.802 470.125Z",
    fill: "#2F2E41",
    style: (_ref3 = {
      fill: "#2F2E41"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.1843 0.1804 0.2549)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.327 462.488L435.384 462.487L431.605 432.099H443.328L443.327 462.488Z",
    fill: "#9E616A",
    style: (_ref4 = {
      fill: "#9E616A"
    }, _defineProperty(_ref4, "fill", "color(display-p3 0.6196 0.3804 0.4157)"), _defineProperty(_ref4, "fillOpacity", 1), _ref4)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.352 470.125L419.742 470.124V469.803C419.742 467.18 420.793 464.665 422.662 462.811C424.531 460.957 427.067 459.915 429.71 459.915L445.353 459.916L445.352 470.125Z",
    fill: "#2F2E41",
    style: (_ref5 = {
      fill: "#2F2E41"
    }, _defineProperty(_ref5, "fill", "color(display-p3 0.1843 0.1804 0.2549)"), _defineProperty(_ref5, "fillOpacity", 1), _ref5)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.182 468.949V224.873C100.182 223.37 100.784 221.928 101.855 220.865C102.927 219.802 104.38 219.205 105.896 219.205H131.395C132.911 219.205 134.364 219.802 135.436 220.865C136.508 221.928 137.11 223.37 137.11 224.873V469.585L100.182 468.949Z",
    fill: "url(#paint0_linear_3432_648)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.402 469.714V275.641C184.402 274.137 185.004 272.696 186.076 271.633C187.148 270.57 188.601 269.973 190.116 269.973H215.616C217.132 269.973 218.585 270.57 219.657 271.633C220.728 272.696 221.33 274.137 221.33 275.641V469.296L184.402 469.714Z",
    fill: "url(#paint1_linear_3432_648)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7477 239.139C34.3724 239.139 34.0051 239.031 33.6902 238.828C33.3754 238.625 33.1264 238.337 32.9734 237.997C32.8205 237.657 32.77 237.28 32.8282 236.912C32.8863 236.544 33.0506 236.201 33.3012 235.924L118.563 141.592L202.472 188.33L286.881 44.062L372.87 114.266C373.067 114.427 373.23 114.624 373.35 114.848C373.471 115.071 373.545 115.316 373.57 115.568C373.595 115.82 373.569 116.075 373.495 116.317C373.42 116.56 373.299 116.785 373.136 116.981C372.974 117.176 372.774 117.338 372.549 117.457C372.324 117.576 372.077 117.65 371.823 117.674C371.568 117.699 371.312 117.673 371.068 117.599C370.823 117.525 370.596 117.404 370.399 117.243L287.945 49.9247L203.911 193.553L119.377 146.468L36.1954 238.498C36.0133 238.7 35.7902 238.861 35.5407 238.972C35.2912 239.082 35.0209 239.139 34.7477 239.139Z",
    fill: "#E2E2E2",
    style: (_ref6 = {
      fill: "#E2E2E2"
    }, _defineProperty(_ref6, "fill", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref6, "fillOpacity", 1), _ref6)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4232 255.205C44.4417 255.205 52.5632 247.149 52.5632 237.211C52.5632 227.274 44.4417 219.218 34.4232 219.218C24.4048 219.218 16.2832 227.274 16.2832 237.211C16.2832 247.149 24.4048 255.205 34.4232 255.205Z",
    fill: "url(#paint2_radial_3432_648)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.646 162.024C128.664 162.024 136.786 153.968 136.786 144.03C136.786 134.093 128.664 126.037 118.646 126.037C108.627 126.037 100.506 134.093 100.506 144.03C100.506 153.968 108.627 162.024 118.646 162.024Z",
    fill: "#CCCCCC",
    style: (_ref7 = {
      fill: "#CCCCCC"
    }, _defineProperty(_ref7, "fill", "color(display-p3 0.8000 0.8000 0.8000)"), _defineProperty(_ref7, "fillOpacity", 1), _ref7)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.867 208.935C212.885 208.935 221.007 200.879 221.007 190.942C221.007 181.004 212.885 172.948 202.867 172.948C192.848 172.948 184.727 181.004 184.727 190.942C184.727 200.879 192.848 208.935 202.867 208.935Z",
    fill: "#E6E6E6",
    style: (_ref8 = {
      fill: "#E6E6E6"
    }, _defineProperty(_ref8, "fill", "color(display-p3 0.9020 0.9020 0.9020)"), _defineProperty(_ref8, "fillOpacity", 1), _ref8)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.089 64.9871C297.108 64.9871 305.229 56.9311 305.229 46.9936C305.229 37.056 297.108 29 287.089 29C277.071 29 268.949 37.056 268.949 46.9936C268.949 56.9311 277.071 64.9871 287.089 64.9871Z",
    fill: "url(#paint3_radial_3432_648)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.052 198.997C459.071 198.997 467.192 190.941 467.192 181.004C467.192 171.066 459.071 163.01 449.052 163.01C439.034 163.01 430.912 171.066 430.912 181.004C430.912 190.941 439.034 198.997 449.052 198.997Z",
    fill: "url(#paint4_radial_3432_648)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.64 321.174C449.429 321.986 466.792 315.842 467.733 325.188C476.669 351.282 476.404 451.308 476.404 451.308L462.799 451.951C462.799 451.951 451.927 372.474 446.786 355.471C444.207 376.137 444.659 455.164 444.659 455.164L432.349 455.806C432.349 455.806 421.308 388.512 421.245 368.761C419.903 354.293 423.194 332.853 421.786 318.867C428.518 320.984 435.603 321.768 442.64 321.174Z",
    fill: "url(#paint5_linear_3432_648)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.64 321.174C449.429 321.986 466.792 315.842 467.733 325.188C476.669 351.282 476.404 451.308 476.404 451.308L462.799 451.951C462.799 451.951 451.927 372.474 446.786 355.471C444.207 376.137 444.659 455.164 444.659 455.164L432.349 455.806C432.349 455.806 421.308 388.512 421.245 368.761C419.903 354.293 423.194 332.853 421.786 318.867C428.518 320.984 435.603 321.768 442.64 321.174Z",
    fill: "#2F2E41",
    style: (_ref9 = {
      fill: "#2F2E41"
    }, _defineProperty(_ref9, "fill", "color(display-p3 0.1843 0.1804 0.2549)"), _defineProperty(_ref9, "fillOpacity", 1), _ref9)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.846 468.849V187.537C352.846 183.929 355.404 181.004 358.56 181.004H384.059C387.215 181.004 389.774 183.928 389.774 187.537V469.586L352.846 468.849Z",
    fill: "url(#paint6_linear_3432_648)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.542 245.473C416.819 239.951 413.493 234.742 409.624 229.941C408.815 229.003 408.079 228.006 407.421 226.959C406.028 224.562 405.613 221.747 404.732 219.125C402.27 211.774 396.129 205.868 394.632 198.266C394.088 195.502 389.491 203.534 390.7 206.96C392.857 213.162 393.136 219.729 395.883 225.719C398.629 231.708 401.856 237.453 404.227 243.577C405.575 247.054 406.65 250.646 408.626 253.859C410.602 257.072 413.686 259.765 417.411 260.247C417.386 257.917 417.742 255.6 418.467 253.384C419.277 250.852 420.715 247.87 419.542 245.473Z",
    fill: "#9E616A",
    style: (_ref10 = {
      fill: "#9E616A"
    }, _defineProperty(_ref10, "fill", "color(display-p3 0.6196 0.3804 0.4157)"), _defineProperty(_ref10, "fillOpacity", 1), _ref10)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.301 249.637C460.134 245.093 460.849 240.56 462.406 236.283C463.002 234.645 463.702 232.98 463.644 231.239C463.559 229.619 462.782 228.135 462.076 226.67C459.64 221.625 457.929 216.278 456.245 210.945L453.006 200.887C451.95 200.119 458.117 199.853 459.433 201.659C463.734 207.584 466.993 214.389 470.401 220.86C471.27 222.402 472.011 224.012 472.616 225.674C473.449 228.366 473.842 231.173 473.783 233.989C473.783 239.252 473.083 244.496 472.357 249.714C471.897 252.985 471.295 256.545 468.801 258.711C466.209 255.421 463.605 252.208 460.301 249.637Z",
    fill: "#9E616A",
    style: (_ref11 = {
      fill: "#9E616A"
    }, _defineProperty(_ref11, "fill", "color(display-p3 0.6196 0.3804 0.4157)"), _defineProperty(_ref11, "fillOpacity", 1), _ref11)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.17 244.43C450.594 244.43 456.613 238.46 456.613 231.096C456.613 223.731 450.594 217.761 443.17 217.761C435.745 217.761 429.727 223.731 429.727 231.096C429.727 238.46 435.745 244.43 443.17 244.43Z",
    fill: "#9E616A",
    style: (_ref12 = {
      fill: "#9E616A"
    }, _defineProperty(_ref12, "fill", "color(display-p3 0.6196 0.3804 0.4157)"), _defineProperty(_ref12, "fillOpacity", 1), _ref12)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.243 217.792C432.092 217.388 432.058 216.949 432.145 216.526C432.232 216.104 432.436 215.713 432.735 215.4C433.07 215.137 433.516 215.039 433.876 214.789C434.388 214.362 434.806 213.837 435.107 213.245C436.025 211.97 437.369 211.059 438.9 210.673C440.431 210.288 442.05 210.453 443.47 211.139C445.691 212.292 447.033 214.602 449.009 216.157C450.012 216.963 451.175 217.561 452.184 218.366C454.206 220.098 455.642 222.404 456.301 224.971C456.956 227.521 457.339 230.133 457.442 232.763C457.548 233.552 457.516 234.353 457.35 235.132C457.146 235.785 456.841 236.402 456.446 236.963C454.415 240.015 451.738 242.787 448.384 244.362C445.03 245.936 440.95 246.193 437.642 244.545C437.309 244.411 437.023 244.184 436.818 243.891C436.63 243.446 436.585 242.953 436.689 242.482C436.869 240.616 436.496 238.739 435.618 237.079C435.003 235.859 434.08 234.809 433.587 233.545C433.13 232.131 432.933 230.646 433.009 229.163C432.95 225.319 433.213 221.492 432.243 217.792Z",
    fill: "#2D293D",
    style: (_ref13 = {
      fill: "#2D293D"
    }, _defineProperty(_ref13, "fill", "color(display-p3 0.1765 0.1608 0.2392)"), _defineProperty(_ref13, "fillOpacity", 1), _ref13)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.959 469.232V333.418C15.959 331.677 18.5174 330.264 21.6731 330.264H47.1728C50.3285 330.264 52.8869 331.678 52.8869 333.418V469.586L15.959 469.232Z",
    fill: "url(#paint7_linear_3432_648)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.353 471H-15.3521C-15.524 471 -15.6888 470.932 -15.8102 470.812C-15.9317 470.691 -16 470.528 -16 470.357C-16 470.187 -15.9317 470.024 -15.8102 469.903C-15.6888 469.783 -15.524 469.715 -15.3521 469.715H515.352C515.524 469.715 515.689 469.783 515.81 469.903C515.932 470.024 516 470.187 516 470.357C516 470.528 515.932 470.691 515.81 470.812C515.689 470.932 515.524 471 515.352 471H515.353Z",
    fill: "#E6E6E6",
    style: (_ref14 = {
      fill: "#E6E6E6"
    }, _defineProperty(_ref14, "fill", "color(display-p3 0.9020 0.9020 0.9020)"), _defineProperty(_ref14, "fillOpacity", 1), _ref14)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.623 468.754V149.516C268.623 145.422 271.181 142.103 274.337 142.103H299.837C302.993 142.103 305.551 145.422 305.551 149.516V469.586L268.623 468.754Z",
    fill: "url(#paint8_radial_3432_648)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.325 205.315C393.545 205.315 396.156 202.725 396.156 199.531C396.156 196.337 393.545 193.748 390.325 193.748C387.105 193.748 384.494 196.337 384.494 199.531C384.494 202.725 387.105 205.315 390.325 205.315Z",
    fill: "#A0616A",
    style: (_ref15 = {
      fill: "#A0616A"
    }, _defineProperty(_ref15, "fill", "color(display-p3 0.6275 0.3804 0.4157)"), _defineProperty(_ref15, "fillOpacity", 1), _ref15)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.11 202.744C458.33 202.744 460.941 200.155 460.941 196.96C460.941 193.766 458.33 191.177 455.11 191.177C451.89 191.177 449.279 193.766 449.279 196.96C449.279 200.155 451.89 202.744 455.11 202.744Z",
    fill: "#A0616A",
    style: (_ref16 = {
      fill: "#A0616A"
    }, _defineProperty(_ref16, "fill", "color(display-p3 0.6275 0.3804 0.4157)"), _defineProperty(_ref16, "fillOpacity", 1), _ref16)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.28 268.556C469.849 268.04 474.487 241.133 474.46 240.526C474.388 237.211 464.191 233.425 462.15 234.743C460.225 235.986 456.873 250.245 454.715 252.842L452.433 248.88H434.293L433.193 250.906C430.813 249.483 428.672 248.172 427.908 247.738C427.646 247.562 427.36 247.422 427.059 247.324C425.173 246.905 423.404 246.08 421.876 244.907C420.386 243.77 413.47 231.857 411.618 232.172C409.525 232.519 402.467 238.573 402.548 244.382C403.436 244.363 414.995 267.29 415.158 268.145C416.045 271.756 418.976 324.426 419.922 326.881C424.279 326.463 420.839 325.718 425.057 326.881C429.598 328.134 434.392 326.778 439.076 326.277C441.027 326.085 442.986 325.999 444.946 326.02C452.072 326.052 462.244 326.444 469.143 328.198C469.182 323.713 465.211 314.009 463.74 309.774C463.548 308.508 463.554 307.221 463.76 305.957C463.948 304.408 467.741 270.268 469.28 268.556Z",
    fill: "#E6E6E6",
    style: (_ref17 = {
      fill: "#E6E6E6"
    }, _defineProperty(_ref17, "fill", "color(display-p3 0.9020 0.9020 0.9020)"), _defineProperty(_ref17, "fillOpacity", 1), _ref17)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.28 268.556C469.849 268.04 474.487 241.133 474.46 240.526C474.388 237.211 464.191 233.425 462.15 234.743C460.225 235.986 456.873 250.245 454.715 252.842L452.433 248.88H434.293L433.193 250.906C430.813 249.483 428.672 248.172 427.908 247.738C427.646 247.562 427.36 247.422 427.059 247.324C425.173 246.905 423.404 246.08 421.876 244.907C420.386 243.77 413.47 231.857 411.618 232.172C409.525 232.519 402.467 238.573 402.548 244.382C403.436 244.363 414.995 267.29 415.158 268.145C416.045 271.756 418.976 324.426 419.922 326.881C424.279 326.463 420.839 325.718 425.057 326.881C429.598 328.134 434.392 326.778 439.076 326.277C441.027 326.085 442.986 325.999 444.946 326.02C452.072 326.052 462.244 326.444 469.143 328.198C469.182 323.713 465.211 314.009 463.74 309.774C463.548 308.508 463.554 307.221 463.76 305.957C463.948 304.408 467.741 270.268 469.28 268.556Z",
    fill: "url(#paint9_radial_3432_648)",
    style: {}
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3432_648",
    x1: 118.646,
    y1: 219.205,
    x2: 118.646,
    y2: 469.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref18 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref18, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref18, "stopOpacity", 1), _ref18)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.18,
    style: {
      stopColor: "white",
      stopOpacity: 0.18
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3432_648",
    x1: 202.866,
    y1: 269.973,
    x2: 202.866,
    y2: 469.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref19 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref19, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref19, "stopOpacity", 1), _ref19)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.18,
    style: {
      stopColor: "white",
      stopOpacity: 0.18
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3432_648",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4232 250.616) rotate(-90) scale(27.064 27.2843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref20 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref20, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref20, "stopOpacity", 1), _ref20)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref21 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref21, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref21, "stopOpacity", 1), _ref21)
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3432_648",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(287.089 60.3983) rotate(-90) scale(27.064 27.2843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref22 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref22, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref22, "stopOpacity", 1), _ref22)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref23 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref23, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref23, "stopOpacity", 1), _ref23)
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3432_648",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(449.052 194.409) rotate(-90) scale(27.064 27.2843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref24 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref24, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref24, "stopOpacity", 1), _ref24)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref25 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref25, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref25, "stopOpacity", 1), _ref25)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3432_648",
    x1: 448.66,
    y1: 318.867,
    x2: 448.66,
    y2: 455.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref26 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref26, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref26, "stopOpacity", 1), _ref26)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3432_648",
    x1: 371.31,
    y1: 181.004,
    x2: 371.31,
    y2: 469.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref27 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref27, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref27, "stopOpacity", 1), _ref27)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.18,
    style: {
      stopColor: "white",
      stopOpacity: 0.18
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3432_648",
    x1: 34.4229,
    y1: 330.264,
    x2: 34.4229,
    y2: 469.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref28 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref28, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref28, "stopOpacity", 1), _ref28)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.18,
    style: {
      stopColor: "white",
      stopOpacity: 0.18
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3432_648",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(287.087 427.828) rotate(-90) scale(246.283 27.7715)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref29 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref29, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref29, "stopOpacity", 1), _ref29)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref30 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref30, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref30, "stopOpacity", 1), _ref30)
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3432_648",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(438.503 315.953) rotate(-90) scale(72.2207 54.082)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref31 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref31, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref31, "stopOpacity", 1), _ref31)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref32 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref32, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref32, "stopOpacity", 1), _ref32)
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3432_648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3432_648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 532,
    height: 442,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-16 29)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount1);
export default __webpack_public_path__ + "static/media/Account-1.1cc7adb4a5450641c432da18634fac1f.svg";
export { ForwardRef as ReactComponent };